import { render, staticRenderFns } from "./EndorsementsEditor.vue?vue&type=template&id=06ac189b"
import script from "./EndorsementsEditor.vue?vue&type=script&lang=ts"
export * from "./EndorsementsEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports